









import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import confirm from 'components/modals/Confirm'
import ContactDelete from 'src/graphql/contact/ContactDelete.gql'
import api from 'src/assets/api/gql'
import { Contact } from 'src/graphql/types'

@Component({
  components: {
  }
})
export default class ContactButtonDelete extends Vue {
  loading = false

  @Prop()
  readonly contact!: Contact

  async action () {
    await confirm({
      title: this.$t('label.deleteConfirm').toString(),
      message: this.contact.name,
      btnRight: this.$t('label.delete').toString(),
      btnRightColor: 'warning'
    })
    this.loading = true
    await api.mutate({
      query: ContactDelete,
      variables: {
        id: this.contact.id
      }
    })
    this.loading = false
    this.$emit('remove')
  }
}
